<!-- @format -->

@let productDetails = coalescedProductDetails();
<div
	id="drawer-content"
	class="compare-grid-drawer--content hmf-position-relative hmf-pl-0"
	[class.vertically-scrollable]="location() !== 'PDP'"
	(scroll)="verticalScrolling()">
	<div
		#hiddenIntersectionElement
		class="hidden-intersection-element"></div>

	@if (!compareGridLoading() && compareGridApiFailed()) {
		<compare-api-failure
			[canRetryApiCall]="apiRetryCounter() < 1"
			(tryAgain)="onTryAgain()"
			(continueBrowsing)="closeDrawer()"
		/>
	} @else if (productDetails?.length === 0 && !compareGridLoading()) {
		<compare-no-products (closeDrawer)="closeDrawer()"/>
	} @else {
	<div
		class="upper-grid-sticky-container hmf-position-sticky hmf-pb-xxs"
		[class.hmf-elevated-shadow]="isSticky()">
		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
			[class.hmf-display-block]="isScrollLeftAllowed()"
			[previous]="true"
			[ariaLabel]="'Scroll Left'"
			[showLeftArrow]="isScrollLeftAllowed()"
			(clickEvent)="scrollToSide('left')">
		</shared-components-carousel-button>

		<div
			#productCardsGridSection
			class="product-card-scrollable-area hmf-display-flex hmf-align-items-flex-start hmf-px-s hmf-px-sm-m"
			(mouseenter)="updateCurrentElement('productCardsGridSection')"
			(touchmove)="updateCurrentElement('productCardsGridSection')"
			(wheel)="updateCurrentElement('productCardsGridSection')"
			(scroll)="onHorizontalScroll($event)">
			@for (compareBarProduct of compareBarProducts(); track trackByCompareBarProduct($index, compareBarProduct)) {
				<compare-components-compare-grid-product-card
					[isCompact]="isSticky()"
					[productDetailsData]="productDetails?.length ? productDetails[$index] : null"
					[compareBarProductData]="compareBarProduct"
					[addCompareQueryParamOnRedirect]="location() === 'PLP'"
					[showRemoveButton]="location() !== 'PDP'"
					(removeButtonClick)="removeProductFromCompareGrid($event, $index)">
				</compare-components-compare-grid-product-card>
			}
			@if (compareBarProducts().length === 1 && location() !== 'PDP') {
				<button
					id="add-more-products-section"
					class="add-more-section hmf-pb-xxs hmf-pt-s hmf-px-xxs hmf-px-sm-xs hmf-py-sm-s"
					[class]="{ 'hmf-p-xxs': isSticky() }"
					title="Add More Products to Compare"
					(click)="closeDrawer()">
					<div
						class="bordered-area hmf-px-m hmf-py-s hmf-display-flex hmf-flex-column align-items-center hmf-justify-content-center">
						<div
							class="add-more-icon hmf-display-flex hmf-align-items-center hmf-justify-content-center">
							<homefield-icon
								name="sign-add"
								width="16px"
								height="16px"
								aria-hidden="true"></homefield-icon>
						</div>
						<p class="hmf-body-bold-l hmf-text-align-center">
							Add more products to compare
						</p>
					</div>
				</button>
			}
		</div>

		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
			[class.hmf-display-block]="isScrollRightAllowed()"
			[previous]="false"
			[ariaLabel]="'Scroll Right'"
			[showRightArrow]="isScrollRightAllowed()"
			(clickEvent)="scrollToSide('right')">
		</shared-components-carousel-button>

		@if (isDrawerScrollable()) {
			<div class="custom-scrollbar hmf-mx-s hmf-mx-sm-m">
				<div
					class="scroll-indicator hmf-position-absolute hmf-px-sm-m"
					#scrollIndicator></div>
			</div>
		}
	</div>

	@if (location() !== 'PDP') {
		<div
			#fulfillmentGridSection
			class="fulfillment-scrollable-area grid-columns-{{
				compareBarProducts().length
			}} hmf-px-s hmf-px-sm-m"
			(mouseenter)="updateCurrentElement('fulfillmentGridSection')"
			(touchmove)="updateCurrentElement('fulfillmentGridSection')"
			(wheel)="updateCurrentElement('fulfillmentGridSection')"
			(scroll)="onHorizontalScroll($event)">
			@for (compareBarProduct of compareBarProducts(); track trackByCompareBarProduct($index, compareBarProduct)) {
				<compare-components-fulfillment-section
					[productEcode]="compareBarProduct.ecode"
					[productDetailsData]="productDetails?.length ? productDetails[$index] : null"
					[compareProductsAvailability]="compareProductsAvailability()">
				</compare-components-fulfillment-section>
			}
		</div>
	}
	<div
		#attributesGridSection
		class="attributes-scrollable-area grid-columns-{{
			compareBarProducts().length
		}} hmf-pb-l hmf-px-s hmf-px-sm-m"
		(mouseenter)="updateCurrentElement('attributesGridSection')"
		(touchmove)="updateCurrentElement('attributesGridSection')"
		(wheel)="updateCurrentElement('attributesGridSection')"
		(scroll)="onHorizontalScroll($event)">
		@for (compareBarProduct of compareBarProducts(); track trackByCompareBarProduct($index, compareBarProduct)) {
			@defer (when productDetails?.length && productDetails[$index]) {
				@for (
					definingAttribute of productDetails[$index]?.style?.definingAttributes;
					track trackByCompareItemAttrribute($index, definingAttribute)
				) {
					<compare-components-attribute-section
						class="hmf-px-s hmf-display-flex hmf-align-items-flex-start hmf-align-self-stretch"
						[expanded]="
							attributeSectionExpandedList()[definingAttribute.identifier] ?? false
						"
						[name]="definingAttribute.name"
						[ecode]="compareBarProduct.ecode"
						[identifier]="definingAttribute.identifier"
						[value]="`${definingAttribute.value}`"
						(expand)="handleAttributeExpand($event)">
					</compare-components-attribute-section>
				}
			} @placeholder {
				<compare-components-skeleton-attribute-section>
				</compare-components-skeleton-attribute-section>
			}
		}
	</div>
	<h3 class="hmf-header-bold-m hmf-pt-xxs hmf-mb-s hmf-px-s hmf-px-sm-m">Specs</h3>
	<div
		#specsGridSection
		class="specs-scrollable-area grid-columns-{{
			compareBarProducts().length
		}} hmf-px-s hmf-px-sm-m"
		(mouseenter)="updateCurrentElement('specsGridSection')"
		(touchmove)="updateCurrentElement('specsGridSection')"
		(wheel)="updateCurrentElement('specsGridSection')"
		(scroll)="onHorizontalScroll($event)">
		@for (compareBarProduct of compareBarProducts(); track trackByCompareBarProduct($index, compareBarProduct)) {
			@defer (when productDetails?.length && productDetails[$index]) {
				@for (
					descriptiveAttribute of productDetails[$index]?.style?.descriptiveAttributes;
					track trackByCompareItemAttrribute($index, descriptiveAttribute)
				) {
					<compare-components-specs-section
						class="hmf-px-s"
						[name]="descriptiveAttribute.name"
						[value]="`${descriptiveAttribute.value}`"></compare-components-specs-section>
				}
			} @placeholder {
				<compare-components-skeleton-specs-section>
				</compare-components-skeleton-specs-section>
			}
		}
	</div>
	}
</div>